import React from 'react';
import App_data from '../../config/App_data';

function CardImageAndCount(props) {
  const { imageURL, count, text, width = '23' } = props;
  return (
    <li>
      <span>
        <img
          src={`${App_data.frontend_url}${imageURL}`}
          className=''
          width={width}
          alt='ImageChange'
        />
      </span>
      <span>{count}</span>
      <div className='tootip_box'>{text}</div>
    </li>
  );
}

export default CardImageAndCount;



// WEBPACK FOOTER //
// ./src/views/ESG/Chapter/CardImageAndCount.jsx